import KnowledgeMapResolver from "resolvers/RTMResolvers/KnowledgeMapResolver";
class KnowledgeService {
  register(connection) {
    this.connection = connection;
    this.resolver = new KnowledgeMapResolver(connection);
  }

  fetchKnowledgeMap(query) {
    return this.connection.fetch({
      type: 'graphql.query',
      query,
    });
  }

  getCollaboratorsList = async (documentId) => {
    const collaborators = await this.resolver.workspaceCompetencyCollaboratorSummary(
      documentId
    );
    return collaborators;
  };

  grantCollaboratorPermission = async (payload) => {
    const result = await this.resolver.workspaceCompetencyPermisssionGrant(payload);
    return result;
  };
  
  revokeCollaboratorPermission = async (payload) => {
    const result = await this.resolver.workspaceCompetencyPermisssionRevoke(payload);
    return result;
  };
}

export default new KnowledgeService();
